// extracted by mini-css-extract-plugin
module.exports =  {"root":"tCaIbDLlJvAHPi2soaQo"};